import { render, staticRenderFns } from "./H2MachineEngineInfo.vue?vue&type=template&id=c813f0b6&scoped=true"
import script from "./H2MachineEngineInfo.vue?vue&type=script&lang=ts"
export * from "./H2MachineEngineInfo.vue?vue&type=script&lang=ts"
import style0 from "./H2MachineEngineInfo.vue?vue&type=style&index=0&id=c813f0b6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c813f0b6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c813f0b6')) {
      api.createRecord('c813f0b6', component.options)
    } else {
      api.reload('c813f0b6', component.options)
    }
    module.hot.accept("./H2MachineEngineInfo.vue?vue&type=template&id=c813f0b6&scoped=true", function () {
      api.rerender('c813f0b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Machine/H2MachineEngineInfo.vue"
export default component.exports